<template>
  <div class="about-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="about-page__container">
      <div class="about-page__welcome sides-padding">
        <div class="container">
          <div class="about-page__welcome-inner">
            <h1 class="title">Мы — Семья!</h1>
            <p class="about-page__welcome-text">
              У нас Вы сможете найти всё необходимое что потребуется малышу: принадлежности и сумка в роддом,
              нарядные конверты, одежду на выписку и повседневную носку, коляски, автокресла, аксессуары для
              грудного вскармливания, подгузники, косметику, игрушки и детскую мебель
            </p>
          </div>
        </div>
      </div>
      <div class="about-page__info sides-padding">
        <div class="container">
          <h2 class="title">
            Baby Market – это концептуальный и сказочный мир для детей и будущих родителей
          </h2>
          <div class="about-page__info-text">
            <p>
              Мы непрерывно и динамично развиваемся, радуя каждого клиента новинками популярных мировых и
              европейских брендов.
            </p>
            <p>
              Концепция Baby Market заключается в экологичности, сдержанности, минимализме и в то же время
              функциональности современного скандинавского стиля, наши предпочтения отдаются натуральным
              материалам, высокому качеству и оригинальным решениям.
            </p>
            <p>
              Наша команда профессиональных, неравнодушных и открытых людей преследует самую важную и
              единственную цель – создание высокого уровня сервиса для клиентов. Обратная связь от Вас – то,
              что делает нас с каждым днем лучше.
            </p>
          </div>
        </div>
      </div>
      <div v-show="false" class="about-page__school sides-padding">
        <div class="container">
          <div class="about-page__school-inner">
            <span class="title">Школа Мам BabyMarket</span>
            <div class="about-page__school-text">
              <p>
                Курс Школы Мам BabyMarket включает в себя более 60 лекции от авторитетных врачей и
                специалистов. За годы существования школа помогла тысячам молодых семей получить полезную
                информацию о беременности, родах, уходу за ребенком, награждена званием «Лучший социальный
                проект».
              </p>
              <a href="#">Познакомься с темами лекций и получи бесплатный доступ</a>
            </div>
          </div>
        </div>
      </div>
      <!--      <div id="policy" class="about-page__policy sides-padding">-->
      <!--        <div class="container">-->
      <!--          <h3 class="title">Политика безопасности</h3>-->
      <!--          <div class="about-page__policy-text">-->
      <!--            <p>-->
      <!--              Товары, представленные в Олант являются гарантировано безопасными. Более 25 лет мы изучаем-->
      <!--              товары для младенцев, сотрудничая с передовыми педиатрами и специалистами. Нашими-->
      <!--              информационными ориентирами являются Всемирная Организация Здравоохранения, Американская-->
      <!--              Академия Педиатрии. Мы изучаем инициативы Ассоциаций Педиатров и других авторитетных-->
      <!--              организаций, отзывы потребителей, публикации авторитетных СМИ. Вы можете быть уверены в-->
      <!--              качестве.-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              Олант является официальным поставщиком на российский рынок торговых марок Bugaboo, Maclaren,-->
      <!--              Elodie, Munchkin, Traumeland, Agu Baby, Dooky, Ggumbi, Gosarison, FunnyLon, Sobble, Mother-K и-->
      <!--              др. Плюс выпускает и реализует товары под собственным брендом Olant baby.-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="about-page__socials sides-padding">
        <div class="container">
          <div class="about-page__socials-inner">
            <h3 class="title">
              Присоединяйтесь к нам в соцсетях, <br />
              чтобы всегда быть на связи!
            </h3>
            <SocialsComponent />
          </div>
        </div>
      </div>
      <div class="about-page__benefits sides-padding">
        <div class="container">
          <h3 class="title">Почему выбирают нас</h3>
          <ul class="about-page__benefits-list">
            <li v-for="(item, i) in benefits" :key="i" class="about-page__benefits-item">
              <span>
                <IconComponent name="tick" />
              </span>
              <span> {{ item.title }} </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import SocialsComponent from "components/SocialsComponent.vue";
import IconComponent from "components/IconComponent.vue";
import DEFAULT_PAGE from "@/graphql/pages/DefaultPage.graphql";

export default {
  name: "AboutPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: DEFAULT_PAGE,
      })
      .then(({ data }) => {
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  components: { IconComponent, SocialsComponent, BreadcrumbsComponent },
  data() {
    return {
      benefits: [
        {
          title: "Работаем по всей России",
        },
        {
          title: "Широкий ассортимент",
        },
        {
          title: "Бесплатная школа мам",
        },
        {
          title: "Персональная помощь",
        },
        {
          title: "Сервисное обслуживание",
        },
        {
          title: "Официальный дистрибьютор",
        },
        {
          title: "Круглосуточная работа",
        },
        {
          title: "Скидки и Акции",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.hash) {
      document.querySelector(this.$route.hash).scrollIntoView({ block: "start", behavior: "smooth" });
    }
  },
  computed: {
    links() {
      return [{ title: "О компании" }];
    },
  },
  metaInfo: {
    title: "О компании",
  },
};
</script>

<style lang="stylus">
.about-page {
  width 100%
  display grid
  grid-gap 30px

  &__container {
    display grid
    align-items start
    gap 50px
  }

  &__welcome {
    padding-top 126px
    padding-bottom 126px
    background url("/static/images/about_welcome.jpg")
    background-repeat no-repeat
    background-size cover
    background-position center
    color: var(--main-color)
    +below(860px) {
      padding-top 80px
      padding-bottom 80px
    }
    +below(640px) {
      padding-top 50px
      padding-bottom 50px
    }
    +below(440px) {
      padding 30px
    }

    &-inner {
      text-align left
      max-width 628px
    }

    .title {
      text-align left
      font-size 2.125em;
      text-transform none
      +below(840px) {
        font-size 1.75em
        line-height 150%
      }
      +below(440px) {
        font-size 1.5em
      }
    }

    &-text {
      font-size: 1.125em
      line-height: 160%;
      +below(440px) {
        font-size 1em
      }
    }
  }

  &__info {
    .title {
      margin-bottom: 30px;
    }

    &-text {
      column-count 2
      column-gap 30px
      +below(640px) {
        column-count 1
      }
    }
  }

  &__school {
    padding-top 95px
    padding-bottom 95px
    background url("/static/images/about_school.jpg")
    background-repeat no-repeat
    background-size cover
    background-position center

    &-inner {
      text-align left
      max-width 580px
      margin-left auto
      display flex
      flex-direction column
    }

    .title {
      font-weight: 700;
      font-size: 1.5em
      line-height: 116%
      margin-bottom: 20px;
    }
  }

  &__policy {
    .title {
      margin-bottom: 40px;
      +below(640px) {
        margin-bottom: 20px;
      }
    }

    &-text {
      column-count 2
      column-gap 30px
      +below(640px) {
        column-count 1
      }
    }
  }

  &__socials {
    &-inner {
      background: var(--gray)
      border-radius: var(--main_radius)
      padding 50px
      display flex
      flex-direction column
      align-items center
      +below(440px) {
        padding 30px
      }
    }

    .title {
      margin-bottom: 15px;
    }
  }

  &__benefits {
    .title {
      margin-bottom: 30px;
    }

    &-list {
      display grid
      grid-template-columns repeat(4, 1fr)
      grid-gap 30px
      +below(1100px) {
        grid-template-columns repeat(3, 1fr)
      }
      +below(860px) {
        grid-template-columns repeat(2, 1fr)
      }
      +below(640px) {
        gap 20px
      }
      +below(540px) {
        grid-template-columns 1fr
      }
      +below(440px) {
        grid-gap 10px
      }
    }

    &-item {
      height: 90px;
      border: 1px solid var(--main-color-75)
      border-radius: var(--small_radius)
      font-weight: 700;
      font-size: 1.125em
      line-height: 140%;
      padding 20px
      display flex
      align-items center
      gap 18px
      +below(640px) {
        height 80px
        padding 15px
        font-size 1em
        gap 12px
      }
      +below(440px) {
        height 70px
      }

      span:first-child {
        position relative
        display flex
        border-radius 50%
        flex-shrink 0
        padding 5px
        background var(--main-color-25)

        .icon {
          width 20px
          height 20px
          background var(--main-color)
          border-radius 50%

          svg {
            flex-shrink 0
            width 24px
            height 24px

            path {
              stroke var(--white)
            }
          }
        }
      }
    }
  }
}
</style>
